module.exports = __webpack_public_path__ + "static/media/paper-3.2ca6ac86.png";